import { type Driver, mapWebData, webDataSuccess } from '@cobliteam/api-lib';

import type { SaveDriverSucceeded } from '../actions';
import type { DriverState } from '../reducer';

export const handleOnSaveDriver = (state: DriverState, action: SaveDriverSucceeded): DriverState => {
  const { saveDriverResponseData, driverData } = action.payload;
  const isAnExistentDriver = 'id' in driverData && driverData.id;

  if (isAnExistentDriver) {
    return {
      ...state,
      saveDriverWebData: webDataSuccess(saveDriverResponseData),
      driversWebData: mapWebData((drivers: Driver[]) =>
        drivers.map((driver) => {
          if (driver.id === saveDriverResponseData.id) {
            return {
              ...driver,
              ...driverData,
            };
          }
          return driver;
        })
      )(state.driversWebData),
    };
  }

  return {
    ...state,
    saveDriverWebData: webDataSuccess(saveDriverResponseData),
    driversWebData: mapWebData((drivers: Driver[]) => {
      drivers.push({
        ...driverData,
        fleetId: saveDriverResponseData.fleetId,
        id: saveDriverResponseData.id,
      });
      return drivers;
    })(state.driversWebData),
  };
};
